<template>
  <div class="content-page">
    <Tabs
      :activeCom.sync="deviceIcon"
      :tabs="dataAnalysisIcon"
      :isSHowIcon="false"
      @handleTabs="handleTabs"
    />

    <div class="dataAnalysis-class" v-loading="loading">
      <LeftTree
        :treeData="treeData"
        :deviceList="deviceList"
        :checkData="checkData"
        :deviceIcon="deviceIcon"
        @treeSearch="treeSearch"
        :optionArray="optionArray"
        @searchDevie="searchDevie"
        @searchMore="searchMore"
        :noMoreFlag="noMoreFlag"
      />

      <listContent
        ref="listContent"
        @clearEchart="clearEchart"
        :saveList="saveList"
        :deviceIcon="deviceIcon"
        @updateEchart="updateEchart"
        :config="(echartContent && echartContent.content) || defaultSetting"
      />
      <outLine
        :saveList="saveList"
        :echartArray="echartArray"
        @middleRefreshFn="middleRefreshFn"
        :deviceIcon="deviceIcon"
        :config="(echartContent && echartContent.content) || defaultSetting"
        @updateEchart="updateEchart"
      />
      <statusEchart
        :saveList="saveList"
        :deviceStatus="deviceStatus"
        :deviceType="deviceType"
        :headerTitle="headerTitle"
        @refreshFn="refreshFn"
      />

      <sensorDetailDialog :show.sync="sensorDetailShow"></sensorDetailDialog>
      <gatewayDetailDialog :show.sync="gatewayDetailShow"></gatewayDetailDialog>
      <displayDetailDialog :show.sync="displayDetailShow"></displayDetailDialog>
      <relayDetailDialog :show.sync="relayDetailShow"></relayDetailDialog>
      <gasDetailDialog :show.sync="gasDetailShow"></gasDetailDialog>
      <magnetismDetailDialog :show.sync="magnetismDetailShow"></magnetismDetailDialog>
    </div>
  </div>
</template>

<script>
import bus from '@/utils/bus'
import sensorDetailDialog from '@/components/dialog/sensorDetail/sensorDetailDialog.vue'
import gatewayDetailDialog from '@/components/dialog/gatewayDetail/gatewayDetailDialog.vue'
import displayDetailDialog from '@/components/dialog/displayDetail/displayDetailDialog.vue'
import relayDetailDialog from '@/components/dialog/relayDetail/relayDetailDialog.vue'
import { deviceTypeIconArray } from '@/utils/icon.js'
import { shareTree } from '@/api/modules/public.js'
import {
  analyseGetDataAnalysis,
  analyseGetDeviceList,
  analyseList
} from '@/api/modules/dataBoard.js'
import LeftTree from '../components/LeftContent.vue'
import Tabs from '../components/Tabs.vue'
import listContent from './List.vue'
import outLine from './OutlineEachrt.vue'
import statusEchart from './statusEchart.vue'
import { formatEchart, tooltipMinFormat } from '@/utils/echart'
import { equiStatusConvert, deviceTypeListConvert } from '@/utils/convert'
import defaultSetting from './config/defaultSetting'
import gasDetailDialog from '@/components/dialog/gasDetail/gasDetailDialog.vue'
import magnetismDetailDialog from '@/components/dialog/magnetismDetail/magnetismDetailDialog.vue'
import { getLanguage } from '@/lang'

export default {
  components: {
    Tabs,
    LeftTree,
    listContent,
    outLine,
    statusEchart,
    sensorDetailDialog,
    gatewayDetailDialog,
    displayDetailDialog,
    relayDetailDialog,
    gasDetailDialog,
    magnetismDetailDialog
  },
  watch: {
    saveList () {
      let config = JSON.parse(
        (this.echartContent && this.echartContent.content) || '{}'
      )
      // 分析项默认值处理
      if (Object.keys(config).length === 0) {
        if (this.deviceIcon === '1') {
          config = { ...defaultSetting }
        } else {
          const { offerline, configure } = defaultSetting
          config = {
            offerline,
            configure
          }
        }
      }
      const deviceList = this.saveList.map(item => item.deviceId).join(',')
      // 这里只有配置分析吗？？？ 没有发现有问题啊

      // this.getEchart(config, deviceList);
      // this.getPieChart(deviceList);
    },
    deviceIcon () {
      this.$delete(this.echartArray, 'offline')
      this.$delete(this.echartArray, 'powerout')
      this.$delete(this.echartArray, 'configure')
      this.query.iDisplayStart = 0
      this.query.iDisplayLength = 30
    }
  },
  data () {
    return {
      defaultSetting,
      // 详情
      sensorDetailShow: false,
      gatewayDetailShow: false,
      displayDetailShow: false,
      relayDetailShow: false,
      // 全组件共用
      deviceIcon: '0',
      dataAnalysisIcon: deviceTypeIconArray,
      // 监测点树
      treeData: [],
      // 下拉框
      optionArray: [
        {
          label: $t($t('integration.state')),
          value: '',
          icon: 'iconfont icon-zhunbeiliangchan'
        },
        {
          label: $t('public.online'),
          value: '1',
          icon: 'iconfont icon-wifi'
        },
        {
          label: $t('public.offline'),
          value: '0',
          icon: 'iconfont icon-wu-WiFi'
        },
        {
          label: $t('public.stop'),
          value: '2',
          icon: 'el-icon-video-play'
        }
      ],
      loading: false,
      // 列表
      query: {
        iDisplayStart: 0,
        iDisplayLength: 30,
        status: null,
        devName: null,
        sceneId: null
      },
      // 列表集合
      deviceList: [],
      checkData: [],
      // 只作用于图表的判断选择
      echartContent: {},
      echartQuery: {
        devCatalog: null,
        devIdList: null,
        method: null,
        way: null,
        time: null,
        startTime: null,
        endTime: null
      },
      echartDevice: '',
      // 柱状+折线
      echartArray: {},
      // 饼图
      deviceStatus: [],
      deviceType: [],
      // 保存的列表
      saveList: [],

      // 饼图文案
      headerTitle: {
        statusTitle: $t('integration.sensor_status'),
        typeTitle: $t('integration.sensor_type')
      },
      // 设备列表是否已无更多
      noMoreFlag: false,

      gasDetailShow: false,
      magnetismDetailShow: false,
    }
  },
  mounted () {
    this.getInitData()
    // 全选
    bus.$on('selectAll', bool => {
      if (bool) {
        const allArray = this.deviceList.filter(item => {
          return !this.saveList.some(ele => ele.deviceId === item.deviceId)
        })
        this.saveList = [...this.saveList, ...allArray]
      } else {
        const allArray = this.saveList.filter(item => {
          return !this.deviceList.some(ele => ele.deviceId === item.deviceId)
        })
        this.saveList = [...allArray]
      }
    })
    // 单选框
    bus.$on('SelectRow', obj => {
      if (!obj.isSelected) {
        this.saveList = this.saveList.filter(
          item => item.deviceId !== obj.row.deviceId
        )
      } else {
        this.saveList.push({ ...obj.row })
      }
    })

    // 刷新echart
    bus.$on('refreshChart', (config, deviceList) => {
      this.getEchart(config, deviceList)
      // this.getPieChart(deviceList);
    })
  },
  beforeDestroy () {
    bus.$off('SelectRow')
    bus.$off('selectAll')
    bus.$off('refreshChart')
  },
  methods: {
    // 对后端返回的结果进行格式化
    handleResult (setting, result, field = {}) {
      const curYearObj = JSON.parse(JSON.stringify(field))
      const lastYearObj = JSON.parse(JSON.stringify(field))
      let chart, target, contrast
      // 在字段后面都带上日期
      Object.keys(curYearObj).forEach(key => {
        const item = curYearObj[key]

        if (setting.startTime) {
          const curYear = setting.startTime.split('-')[0]
          item.name = `${item.name}(${curYear})`
        } else if (setting.time) {
          const curYear = setting.time.split('-')[0]
          item.name = `${item.name}(${curYear})`
        }
      })
      Object.keys(lastYearObj).forEach(key => {
        const item = lastYearObj[key]
        if (setting.startTime) {
          const lastYear = setting.startTime.split('-')[0] * 1 - 1 + ''
          item.name = `${item.name}(${lastYear})`
        } else if (setting.time) {
          const lastYear = setting.time.split('-')[0] * 1 - 1 + ''
          item.name = `${item.name}(${lastYear})`
        }
      })
      switch (setting.method) {
        case 0:
          chart = formatEchart(result.stats, field)
          break
        case 1:
          contrast = formatEchart(result.yoy.contrast, lastYearObj)
          target = formatEchart(result.yoy.target, curYearObj)
          contrast.series = [...contrast.series, ...target.series]
          chart = contrast
          break
        case 2:
          chart = formatEchart(
            [result.ringCompare.contrast, result.ringCompare.target],
            field
          )
          break
      }
      return chart
    },
    // 树形点击
    treeSearch ({ id, carrierId }) {
      this.deviceList = []
      // this.checkData = [];
      this.query.sceneId = id
      this.query.carrierId = carrierId
      this.getListFn(true)
    },
    // 全选
    // checkAll(row) {
    // if (row.checkAll) {
    //   const allArray = this.deviceList.filter(item => {
    //     return !this.saveList.some(ele => ele.deviceId === item.deviceId)
    //   }
    //   )
    //   this.saveList = [...this.saveList, ...allArray];
    // } else {
    //   const allArray = this.saveList.filter(item => {
    //     return !this.deviceList.some(ele => ele.deviceId === item.deviceId)
    //   }
    //   )
    //   this.saveList = [...allArray]
    // }
    // },
    // 查询
    searchDevie (row) {
      this.query.status = row.devCatalog
      this.query.devName = row.inputValue
      this.getListFn(true)
    },
    handleTabs (item) {
      this.getInitData()
      if (this.deviceIcon === '0') {
        this.headerTitle = {
          statusTitle: $t('integration.sensor_status'),
          typeTitle: $t('integration.sensor_type')
        }
      } else if (this.deviceIcon === '1') {
        this.headerTitle = {
          statusTitle: $t('device.gateway_status'),
          typeTitle: $t('integration.gateway_type_')
        }
      } else if (this.deviceIcon === '2') {
        this.headerTitle = {
          statusTitle: $t('integration.display_status'),
          typeTitle: $t('device.display_type')
        }
      } else if (this.deviceIcon === '3'){
        this.headerTitle = {
          statusTitle: $t('integration.relay_status'),
          typeTitle: $t('integration.relay_type')
        }
      }else if (this.deviceIcon === '5'){
        this.headerTitle = {
          statusTitle: $t('integration.gas_status'),
          typeTitle: $t('integration.gas_type')
        }
      }else{
        this.headerTitle = {
          statusTitle: $t('integration.magnetism_status'),
          typeTitle: $t('integration.magnetism_type')
        }
      }
      // 改变右侧文案
    },
    async getInitData () {
      this.loading = true
      // let { item } = await this.$store.dispatch("carrierTree/carrierTree");
      const { result } = await shareTree({
        carrier: true,
        addAllNode: false
      })
      this.treeData = (result && result.item) || []
      this.query.sceneId = this.treeData[0].scopeId
      // // 查列表
      this.getListFn()
      // this.getSaveList();
    },
    async getListFn () {
      const {
        result: {
          deviceData,
          page: { result }
        }
      } = await analyseList(this.query, this.deviceIcon)
      // 勾选的数据
      const checkArray =
        deviceData && deviceData.deviceId
          ? deviceData.deviceId.split(',').map(item => ({ deviceId: item }))
          : []
      // 列表的数据
      this.deviceList = [...result]
      this.checkData = checkArray
      // 保存的列表数据
      const { result: newResult } = await analyseGetDeviceList(this.deviceIcon)
      this.saveList = [...newResult]
      this.echartContent = deviceData
      this.getEchart()
      this.getPieChart()
      this.loading = false
      // this.httpWay(this.saveList);
    },

    updateEchart ({ childrenList, obj = {} }) {
      let listIds = this.deviceList.map(item => item.deviceId).join(',')
      if (childrenList.length > 0) {
        listIds = childrenList.map(item => item.deviceId).join(',')
      }
      this.getEchart(obj, listIds)
    },
    // 刷新饼状图
    getPieChart (deviceList, params) {
      if (!params) {
        this.getSensorStatus(deviceList)
        this.getSensorType(deviceList)
        return
      }
      if (params.sensorStatus) {
        this.getSensorStatus(deviceList)
      }
      if (params.sensorType) {
        this.getSensorType(deviceList)
      }
    },
    getSaveList () {
      analyseGetDeviceList(this.deviceIcon).then(({ result }) => {
        this.saveList = result
      })
    },
    // 获取离线分析
    getOfflineAnal (offline, param) {
      analyseGetDataAnalysis({ ...offline, ...param }, 'offerline')
        .then(({ result }) => {
          const chart = this.handleResult(offline, result, {
            yAxis: {
              name: $t('integration.offline_duration'),
              type: 'bar',
              yAxisIndex: 0,
              triggerEvent: true,
              formatter: value => {
                if (String(value).length > 4) {
                  return (
                    String(value).substring(0, 4) + '...' + $t('public.minute')
                  )
                } else {
                  return value + $t('public.minute')
                }
              }
            },
            series: {
              name: $t('integration.offline_times'),
              type: 'line',
              yAxisIndex: 1,
              formatter: value => {
                return value + $t('public.times')
              }
            }
          })

          // 离线分析的tooltip需要进行特殊处理  需要格式化分数据
          chart.tooltip = {
            formatter: tooltipMinFormat
          }

          this.$delete(this.echartArray, 'offline')
          this.$nextTick(() => this.$set(this.echartArray, 'offline', chart))
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取配置分析
    getConfigureAnal (configure, param) {
      analyseGetDataAnalysis({ ...configure, ...param }, 'configure')
        .then(({ result }) => {
          const chart = this.handleResult(configure, result, {
            yAxis: {
              name: $t('integration.configuration_success_times'),
              type: 'bar',
              yAxisIndex: 0,
              formatter: value => {
                return value + $t('public.times')
              }
            },
            series: {
              name: $t('integration.configuration_times'),
              type: 'line',
              yAxisIndex: 1,
              formatter: value => {
                return value + $t('public.times')
              }
            }
          })
          this.$delete(this.echartArray, 'configure')
          this.$nextTick(() => this.$set(this.echartArray, 'configure', chart))
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取断电分析
    getPoweroutAnal (powerout, param) {
      analyseGetDataAnalysis({ ...powerout, ...param }, 'powerout')
        .then(({ result }) => {
          const chart = this.handleResult(powerout, result, {
            yAxis: {
              name: $t('integration.duration_of_power_failure'),
              type: 'bar',
              yAxisIndex: 0,
              formatter: value => {
                return value + $t('public.minute')
              }
            },
            series: {
              name: $t('integration.outage_times'),
              type: 'line',
              yAxisIndex: 1,
              formatter: value => {
                return value + $t('public.times')
              }
            }
          })
          chart.tooltip = {
            formatter: tooltipMinFormat
          }
          this.$delete(this.echartArray, 'powerout')
          this.$nextTick(() => this.$set(this.echartArray, 'powerout', chart))
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取传感器状态
    getSensorStatus (device) {
      analyseGetDataAnalysis(
        {
          devCatalog: this.deviceIcon,
          devIdList: device
        },
        'deviceStatus'
      ).then(({ result }) => {
        result.deviceStatus && result.deviceStatus.map(item => {
          item.name = equiStatusConvert(item.name)
            ? this.$t(equiStatusConvert(item.name).title)
            : item.name
        })
        this.deviceStatus = result.deviceStatus ? result.deviceStatus : []
      })
    },
    // 获取传感器类型
    getSensorType (device) {
      analyseGetDataAnalysis(
        {
          devCatalog: this.deviceIcon,
          devIdList: device
        },
        'deviceType'
      ).then(({ result }) => {
        this.deviceType = result.deviceType ?  result.deviceType.map((item, index) => {
          return {
            value: item.value,
            // name: item.name
            name: getLanguage() === 'zh_CN'? item.name: deviceTypeListConvert[item.code]
          }
        }) : []
      })
    },
    getEchart (obj, listIds) {
      // 默认值赋值
      if (!obj) {
        const config = JSON.parse(
          (this.echartContent && this.echartContent.content) || '{}'
        )
        obj = config
        if (Object.keys(obj).length === 0) {
          obj = defaultSetting
        }
      }

      if (typeof obj === 'string') {
        obj = JSON.parse(obj)
      }
      this.echartQuery.devCatalog = this.deviceIcon
      if (!listIds) { listIds = this.saveList.map(item => item.deviceId).join(',') }
      if (!listIds) {
        this.echartArray = {}
        return
      }
      const params = {
        devCatalog: this.deviceIcon,
        devIdList: listIds
      }

      if (obj.offerline && !obj.offerline.default) {
        this.getOfflineAnal(obj.offerline, params)
      }
      if (obj.powerout && this.deviceIcon == 1 && !obj.powerout.default) {
        this.getPoweroutAnal(obj.powerout, params)
      }
      if (obj.configure && !obj.configure.default) {
        this.getConfigureAnal(obj.configure, params)
      }
    },
    typeEchartFn (item, result = {}) {
      // this.echartArray = [];
      // 折线图
      if (item !== 'deviceStatus' && item !== 'deviceType') {
        if (Object.keys(result).length > 0) {
          let barArray = []
          let typeArray = []
          let xAxis = []
          let series = []

          Object.keys(result).forEach(key => {
            // 如果是一个数组  则为 统计类型
            if (Array.isArray(result[key])) {
              typeArray = result[key].map(opt => opt.yAxis) // 折线 --时长
              barArray = result[key].map(opt => opt.series) // 柱状 -- 次数
              xAxis = result[key].map(opt => opt.xAxis) // x轴
              series = [
                {
                  name: $t('integration.configuration_success_times'),
                  type: 'bar',
                  data: barArray,
                  yAxisIndex: 0
                },
                {
                  name: $t('integration.offline_duration'),
                  type: 'line',
                  data: typeArray,
                  yAxisIndex: 1
                }
              ]
            }
            // 如果是一个对象  则为同比类型
            if (
              Object.prototype.toString.call(result[key]) === '[object Object]'
            ) {
              // console.log('item==>', this.echartContent);
              // 对比数据
              barArray = result[key].contrast.map(opt => opt.series) // 柱状
              typeArray = result[key].contrast.map(opt => opt.yAxis) // 折线
              // 同比环比数据
              const newBarArray = result[key].target.map(opt => opt.series)
              const newTypeArray = result[key].target.map(opt => opt.yAxis)
              xAxis = result[key].contrast.map(opt => opt.xAxis.slice(5)) // x轴
              series = [
                {
                  name: `离线次数${result[key].contrast[0].xAxis.slice(0, 4)}`,
                  type: 'bar',
                  yAxisIndex: 0,
                  data: barArray
                },
                {
                  name: `离线次数${result[key].target[0].xAxis.slice(0, 4)}`,
                  type: 'bar',
                  yAxisIndex: 1,
                  data: newBarArray
                },
                {
                  name: `离线时长${result[key].contrast[0].xAxis.slice(0, 4)}`,
                  type: 'line',
                  data: typeArray
                },
                {
                  name: `离线时长${result[key].target[0].xAxis.slice(0, 4)}`,
                  type: 'line',
                  data: newTypeArray
                }
              ]
            }
          })
          // 传感器
          // if (this.deviceIcon === '0') {
          // 离线分析
          if (item === 'offerline') {
            this.echartArray.push({
              headerTitle: $t('integration.offline_analysis'),
              xAxis,
              yAxis: [
                {
                  type: 'value',
                  name: $t('integration.offline_times'),
                  axisLine: {
                    show: false,
                    lineStyle: {
                      color: '#5470C6'
                    }
                  },
                  axisLabel: {
                    formatter: '{value} 次'
                  }
                },
                {
                  type: 'value',
                  name: $t('integration.offline_duration'),
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: '#91CC75'
                    }
                  },
                  axisLabel: {
                    formatter: '{value} 分'
                  }
                }
              ],
              series,
              rest: {
                isShow: true
              },
              type: 'offerline'
            })
          }
          // 配置状态
          else if (item === 'configure') {
            this.echartArray.push({
              headerTitle: $t('integration.configuration_analysis'),
              xAxis,
              series,
              yAxis: [
                {
                  type: 'value',
                  name: $t('integration.offline_times'),
                  axisLine: {
                    show: false,
                    lineStyle: {
                      color: '#5470C6'
                    }
                  },
                  axisLabel: {
                    formatter: '{value} 次'
                  }
                },
                {
                  type: 'value',
                  name: $t('integration.offline_duration'),
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: '#91CC75'
                    }
                  },
                  axisLabel: {
                    formatter: '{value} 分'
                  }
                }
              ],
              rest: {
                isShow: true
              },
              type: 'configure'
            })
          }
          // 断电分析
          else if (item === 'powerout') {
            this.echartArray.push({
              headerTitle: $t('integration.outage_analysis'),
              xAxis,
              yAxis: [
                {
                  type: 'value',
                  name: $t('integration.offline_times'),
                  axisLine: {
                    show: false,
                    lineStyle: {
                      color: '#5470C6'
                    }
                  },
                  axisLabel: {
                    formatter: '{value} 次'
                  }
                },
                {
                  type: 'value',
                  name: $t('integration.offline_duration'),
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: '#91CC75'
                    }
                  },
                  axisLabel: {
                    formatter: '{value} 分'
                  }
                }
              ],
              series,
              rest: {
                isShow: true
              },
              type: 'powerout'
            })
          }
        }
      }
      // 饼图
      else {
        if (result.deviceStatus) {
          this.deviceStatus = [...result.deviceStatus].map(item => {
            return {
              value: item.value,
              //   在线 离线 停止 未确认
              name:
                item.name === '0'
                  ? $t('public.offline')
                  : item.name === '1'
                    ? $t('integration.on-line')
                    : $t('integration.stop_it')
            }
          })
        }
        if (result.deviceType) {
          this.deviceType = [...result.deviceType]
        }
      }
    },
    // 更新中间 待优化
    middleRefreshFn ({ index, type }) {
      const { newSaveList } = this.$refs.listContent
      const query = JSON.parse(this.echartContent.content)
      query[type].devCatalog = this.deviceIcon
      query[type].devIdList = newSaveList.map(item => item.deviceId).join(',')
      analyseGetDataAnalysis(query[type], type).then(({ result }) => {
        if (Object.keys(result).length > 0) {
          let barArray = []
          let typeArray = []
          let xAxis = []
          let series = []
          Object.keys(result).forEach(key => {
            // 如果是一个数组  则为 统计类型
            if (Array.isArray(result[key])) {
              typeArray = result[key].map(opt => opt.yAxis) // 折线 --时长
              barArray = result[key].map(opt => opt.series) // 柱状 -- 次数
              xAxis = result[key].map(opt => opt.xAxis) // x轴
              series = [
                {
                  name: $t('integration.offline_times'),
                  type: 'bar',
                  data: barArray,
                  yAxisIndex: 0
                },
                {
                  name: $t('integration.offline_duration'),
                  type: 'line',
                  data: typeArray,
                  yAxisIndex: 1
                }
              ]
            }
            // 如果是一个对象  则为同比类型
            if (
              Object.prototype.toString.call(result[key]) === '[object Object]'
            ) {
              // console.log('item==>', this.echartContent);
              // 对比数据
              barArray = result[key].contrast.map(opt => opt.series) // 柱状
              typeArray = result[key].contrast.map(opt => opt.yAxis) // 折线
              // 同比环比数据 需要区分两个x轴
              const newBarArray = result[key].target.map(opt => opt.series)
              const newTypeArray = result[key].target.map(opt => opt.yAxis)
              xAxis = result[key].contrast.map(opt => opt.xAxis.slice(5)) // x轴
              series = [
                {
                  name: `离线次数${result[key].contrast[0].xAxis.slice(0, 4)}`,
                  type: 'bar',
                  yAxisIndex: 0,
                  data: barArray
                },
                {
                  name: `离线次数${result[key].target[0].xAxis.slice(0, 4)}`,
                  type: 'bar',
                  yAxisIndex: 1,
                  data: newBarArray
                },
                {
                  name: `离线时长${result[key].contrast[0].xAxis.slice(0, 4)}`,
                  type: 'line',
                  data: typeArray
                },
                {
                  name: `离线时长${result[key].target[0].xAxis.slice(0, 4)}`,
                  type: 'line',
                  data: newTypeArray
                }
              ]
            }
          })
          // 传感器
          // if (this.deviceIcon === '0') {

          // 离线分析
          if (type === 'offerline') {
            const query = {
              headerTitle: $t('integration.offline_analysis'),
              xAxis,
              yAxis: [
                {
                  type: 'value',
                  name: $t('integration.offline_times'),
                  axisLine: {
                    show: false,
                    lineStyle: {
                      color: '#5470C6'
                    }
                  },
                  axisLabel: {
                    formatter: '{value} 次'
                  }
                },
                {
                  type: 'value',
                  name: $t('integration.offline_duration'),
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: '#91CC75'
                    }
                  },
                  axisLabel: {
                    formatter: '{value} 分'
                  }
                }
              ],
              series,
              rest: {
                isShow: true
              },
              type: 'offerline'
            }
            const newArray = this.echartArray.filter(item => item.type !== type)
            newArray.splice(index, 0, query)
            this.echartArray = [...newArray]
          }
          // 配置状态
          else if (type === 'configure') {
            const query = {
              headerTitle: $t('integration.configuration_analysis'),
              xAxis,
              series,
              yAxis: [
                {
                  type: 'value',
                  name: $t('integration.offline_times'),
                  axisLine: {
                    show: false,
                    lineStyle: {
                      color: '#5470C6'
                    }
                  },
                  axisLabel: {
                    formatter: '{value} 次'
                  }
                },
                {
                  type: 'value',
                  name: $t('integration.offline_duration'),
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: '#91CC75'
                    }
                  },
                  axisLabel: {
                    formatter: '{value} 分'
                  }
                }
              ],
              rest: {
                isShow: true
              },
              type: 'configure'
            }

            const newArray = this.echartArray.filter(item => item.type !== type)
            newArray.splice(index, 0, query)
            this.echartArray = [...newArray]
          }
          // 断电分析
          else if (type === 'powerout') {
            const query = {
              headerTitle: $t('integration.outage_analysis'),
              xAxis,
              yAxis: [
                {
                  type: 'value',
                  name: $t('integration.offline_times'),
                  axisLine: {
                    show: false,
                    lineStyle: {
                      color: '#5470C6'
                    }
                  },
                  axisLabel: {
                    formatter: '{value} 次'
                  }
                },
                {
                  type: 'value',
                  name: $t('integration.offline_duration'),
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: '#91CC75'
                    }
                  },
                  axisLabel: {
                    formatter: '{value} 分'
                  }
                }
              ],
              series,
              rest: {
                isShow: true
              },
              type: 'powerout'
            }
            const newArray = this.echartArray.filter(item => item.type !== type)
            newArray.splice(index, 0, query)
            this.echartArray = [...newArray]
          }
          //   else {
          //     // 数据初始化
          //   }
          // }
        }
        // else if(){}
      })
    },
    // 更新右侧
    refreshFn ({ item }) {
      const { newSaveList } = this.$refs.listContent
      this.echartQuery.devIdList = newSaveList
        .map(item => item.deviceId)
        .join(',')
      analyseGetDataAnalysis(this.echartQuery, item).then(({ result }) => {
        if (item === 'deviceStatus') {
          return {
            value: item.value,
            //   在线 离线 停止 未确认
            name:
              item.name === '0'
                ? $t('public.offline')
                : item.name === '1'
                  ? $t('integration.on-line')
                  : $t('integration.stop_it')
          }
        }
        this[item] = [...result[item]]
      })
    },
    clearEchart () {
      this.echartArray = {}
    },
    searchMore () {
      this.query.iDisplayStart += this.query.iDisplayLength

      analyseList(this.query, this.deviceIcon).then(({ result: res }) => {
        console.log(res)
        this.deviceList = this.deviceList.concat(res.page.result)

        if (res.page.pageInfo.total <= this.deviceList.length) {
          this.noMoreFlag = true
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content-page {
  height: calc(100% - 56px);
}

.dataAnalysis-class {
  height: 100%;
  display: flex;
}
</style>
